import { useQueryVerifications } from "../../query/onboarding/queries/useQueryVerifications";
import { usePaymentsStatusQuery } from "../../query/payments/queries";
import { VerificationStatus } from "@wingspanhq/payments/dist/interfaces";

export const useTaxVerificationVersion = () => {
  const queryVerifications = useQueryVerifications();
  const queryPaymentsSettings = usePaymentsStatusQuery();

  const defaultTaxVerificationStatus = queryVerifications.isFetched
    ? queryVerifications.data?.tax
    : undefined;

  const isLegacyTaxVerification = queryPaymentsSettings.isFetched
    ? queryPaymentsSettings.data?.verifications.taxDocumentation ===
      VerificationStatus.Verified
    : false;

  const isDefaultTaxVerificationNotActive =
    defaultTaxVerificationStatus === undefined ||
    defaultTaxVerificationStatus === "None" ||
    defaultTaxVerificationStatus === "UpdateRequired";

  const isLegacyOnlyTaxVerification =
    isDefaultTaxVerificationNotActive && isLegacyTaxVerification;

  return {
    isLoading:
      !queryVerifications.isFetched || !queryPaymentsSettings.isFetched,
    isLegacyTaxVerification,
    isLegacyOnlyTaxVerification
  };
};
